import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';

class NewContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameEmpty: false
    }
  }
  onSave = () => {
    const { cancelCreateContact, createContact } = this.props;

    var titleVal = this.refs.title.value;
    var nameVal = this.refs.name.value;
    var telephoneVal = this.refs.telephone.value;
    var emailVal = this.refs.email.value;

    //if name is not filled tell user
    if(nameVal.replace(/^\s+|\s+$/g, "").length < 1){
      //do alert
      this.refs.name.value = "";
      this.setState({
        nameEmpty: true
      })
      return;
    }

    var contact = {
      name: nameVal,
      title: titleVal,
      telephone: telephoneVal,
      email: emailVal
    }

    createContact(contact)

    cancelCreateContact();
  };
  onNameInputChange = () => {
    if (this.refs.name.value.replace(/^\s+|\s+$/g, "").length > 0 && this.state.nameEmpty){
      this.setState({
        nameEmpty: false
      })
    }
  };
  render () {
    const { cancelCreateContact } = this.props;
    return (
      <div style={[styles.contact]}>
        <div>
          <div style={styles.line}>
            <input
              type="text"
              placeholder="Titel"
              ref="title"
              style={styles.lineInputField}/>
            <i onClick={this.onSave} style={[styles.saveIcon]} className="fa fa-floppy-o waves-icon" />
            <i onClick={cancelCreateContact} style={[styles.editIcon, styles.editIconActive]} className="fa fa-times waves-icon" />
          </div>
          <div style={styles.line}>
            <i className="fa fa-user" style={styles.icons}></i>
            <input
              type="text"
              placeholder={this.state.nameEmpty ? "Navn skal udfyldes..." : "Navn"}
              ref="name"
              onChange={this.onNameInputChange}
              style={[styles.lineInputField, this.state.nameEmpty && styles.nameError]}/>
          </div>
          <div style={styles.line}>
            <i className="fa fa-phone" style={styles.icons}></i>
            <input
              type="text"
              placeholder="Telefon"
              ref="telephone"
              style={styles.lineInputField}/>
          </div>
          <div style={styles.line}>
            <i className="fa fa-envelope-o" style={[styles.icons, styles.mailIcon]}></i>
            <input
              type="text"
              placeholder="Email"
              ref="email"
              style={styles.lineInputField}/>
          </div>
        </div>
      </div>
      );
    }
}

var styles = {
  contact : {
    color: semanticColors.text,
    backgroundColor: greyScaleColors.greyLighter,
    fontSize: '14px',
    padding:'0 10px',
    height: '140px',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'left'
  },
  title:{
    color: greyScaleColors.greyLight
  },
  line: {
    height: '35px',
    width: '100%',
    paddingLeft: '40px',
    position: 'relative',
    lineHeight: '35px',
    paddingRight: '60px'
  },
  a: {
    color: semanticColors.primary,
    ':hover': {
      color: semanticColors.primaryDark
    }
  },
  icons: {
    position: 'absolute',
    left: '10px',
    lineHeight: '37px',
    fontSize: '20px'
  },
  mailIcon: {
    fontSize: '18px'
  },
  editIcon: {
    position: 'absolute',
    right: '0',
    fontSize: '20px',
    lineHeight:'30px',
    width:' 30px',
    height: '30px',
    marginTop: '5px',
    cursor: 'pointer',
    color: semanticColors.text
  },
  saveIcon:{
    position: 'absolute',
    right: '30px',
    fontSize: '20px',
    cursor: 'pointer',
    lineHeight:'30px',
    marginTop: '5px',
    width:' 30px',
    height: '30px',
    color: semanticColors.text
  },
  lineInputField: {
    height: '31px',
    lineHeight: '31px',
    border: 'none',
    width: '100%',
    paddingLeft: '5px',
    borderRadius: '2px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset'
  },
  nameError: {
    backgroundColor: '#fee',
     border: '1px solid #b94a48'
  }
}
  NewContact.propTypes = {
    createContact: PropTypes.func.isRequired,
    cancelCreateContact: PropTypes.func.isRequired
  };
export default Radium(NewContact);


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/newContact.jsx